// removed by extract-text-webpack-plugin
module.exports = {"container":"player__container___Zx1mc","name":"player__name___1jV-r","score":"player__score___2f2VE"};


//////////////////
// WEBPACK FOOTER
// ./components/Player/player.css
// module id = 270
// module chunks = 0